import { useState } from 'react';
import ReportPage from './ReportPage';
import CommissionTrackingView from './CommissionTrackingView';
import NLSRxOrdersReport from './NLSRxOrdersReport';
import WiseW9Report from './WiseW9Report';

function CommissionTracking() {
  const [currentView, setCurrentView] = useState('dashboard');
  
  const renderView = () => {
    switch(currentView) {
      case 'dashboard':
        return (
          <ReportPage 
            onCommissionClick={() => setCurrentView('commission')}
            onNLSClick={() => setCurrentView('nls')}
            onWiseW9Click={() => setCurrentView('wisew9')}
          />
        );
      case 'commission':
        return <CommissionTrackingView onBack={() => setCurrentView('dashboard')} />;
      case 'nls':
        return <NLSRxOrdersReport hideNLSRxSection={() => setCurrentView('dashboard')} />;
      case 'wisew9':
        return <WiseW9Report hideWiseW9Section={() => setCurrentView('dashboard')} />;
      default:
        return null;
    }
  };

  return <div className="w-full">{renderView()}</div>;
}

export default CommissionTracking;
